if (!customElements.get('bundle-combo')) {
  customElements.define(
    'bundle-combo',
    class BundleCombo extends HTMLElement {
      connectedCallback() {
        this.cards = Array.from(this.querySelectorAll('offer-product-card'));
        this.totalEl = this.querySelector('[data-bundle-total]');
        this.savingsEl = this.querySelector('[data-bundle-savings]');
        this.savingsWrap = this.querySelector('[data-bundle-savings-wrap]');
        this.compareEl = this.querySelector('[data-bundle-total-compare]');
        this.addButton = this.querySelector('[data-bundle-add]');
        this.errorEl = this.querySelector('[data-bundle-error]');
        this.cartDrawerElement = document.querySelector('cart-drawer');

        this.addEventListener('opc:variant:change', this.recompute.bind(this));

        if (this.addButton) {
          this.addButton.addEventListener('click', this.handleAddAll.bind(this));
        }

        this.recompute();
      }

      formatMoney(cents) {
        if (window.FoxTheme && FoxTheme.Currency && FoxTheme.settings) {
          return FoxTheme.Currency.formatMoney(cents, FoxTheme.settings.moneyFormat);
        }
        return (cents / 100).toFixed(2);
      }

      recompute() {
        // API-driven combos (combo-list.js): the middleware already allocated the discount per
        // line, rounded to cents, the same way Shopify does — so these numbers match the cart
        // exactly. Never recompute them here.
        if (this.dataset.total !== undefined) {
          const toCents = (v) => {
            const n = parseFloat(v);
            return Number.isFinite(n) ? Math.round(n * 100) : 0;
          };
          const total = toCents(this.dataset.total);
          const discounted = toCents(this.dataset.discountedTotal);
          const savings = toCents(this.dataset.savings);

          if (this.totalEl) {
            this.totalEl.innerHTML = this.formatMoney(discounted || total);
            this.totalEl.classList.toggle('has-savings', savings > 0);
          }
          if (this.compareEl) {
            this.compareEl.innerHTML = this.formatMoney(total);
            this.compareEl.hidden = savings <= 0;
          }
          if (this.savingsEl) this.savingsEl.innerHTML = this.formatMoney(savings);
          if (this.savingsWrap) this.savingsWrap.hidden = savings <= 0;
          return;
        }

        // Legacy Liquid-rendered combos: sum the cards' compare-at deltas.
        let total = 0;
        let savings = 0;

        this.cards.forEach((card) => {
          const price = Number(card.dataset.price || 0);
          const compare = Number(card.dataset.compare || 0);
          total += price;
          if (compare > price) {
            savings += compare - price;
          }
        });

        if (this.totalEl) {
          this.totalEl.innerHTML = this.formatMoney(total);
          this.totalEl.classList.toggle('has-savings', savings > 0);
        }
        if (this.savingsEl) {
          this.savingsEl.innerHTML = this.formatMoney(savings);
        }
        if (this.savingsWrap) {
          this.savingsWrap.hidden = savings <= 0;
        }
      }

      get selectedItems() {
        // Prefer the exact pair the middleware built the discount for.
        if (this.dataset.items) {
          try {
            const items = JSON.parse(this.dataset.items);
            if (Array.isArray(items) && items.length) return items;
          } catch (e) {
            console.warn('[combos] bad data-items', e);
          }
        }
        // Fallback: the hidden inputs inside the cards.
        return this.cards
          .map((card) => {
            const input = card.querySelector('.product-variant-id');
            if (!input || input.disabled || !input.value) return null;
            return { id: input.value, quantity: 1 };
          })
          .filter(Boolean);
      }

      showError(message = false) {
        if (this.errorEl) {
          this.errorEl.hidden = !message;
          if (message) this.errorEl.textContent = message;
        } else if (message) {
          alert(message);
        }
      }

      toggleLoading(state) {
        if (!this.addButton) return;
        this.addButton.classList.toggle('btn--loading', state);
        if (state) {
          this.addButton.setAttribute('disabled', 'true');
        } else {
          this.addButton.removeAttribute('disabled');
        }
      }

      handleAddAll(event) {
        event.preventDefault();
        this.lastClickedElement = event.currentTarget;

        const items = this.selectedItems;
        if (!items.length) {
          this.showError('Моля, изберете налични варианти.');
          return;
        }
        // Both or nothing: never send a partial pair (one /cart/add.js call is atomic anyway).
        if (items.length < 2 || this.dataset.available === 'false') {
          this.showError('Комбото не е налично в момента.');
          return;
        }

        const payload = { items };

        if (document.body.classList.contains('cart-template') || FoxTheme.settings.cartType != 'drawer') {
          FoxTheme.utils.postLink(FoxTheme.routes.cart_add_url, { parameters: { ...payload } });
          return;
        }

        this.showError(false);
        this.toggleLoading(true);

        let sectionsToBundle = [];
        document.documentElement.dispatchEvent(
          new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
        );

        const body = JSON.stringify({
          ...payload,
          sections: sectionsToBundle,
          section_url: window.pathname,
        });

        fetch(`${FoxTheme.routes.cart_add_url}`, { ...FoxTheme.utils.fetchConfig('javascript'), ...{ body } })
          .then((response) => response.json())
          .then(async (parsedState) => {
            if (parsedState.status) {
              this.showError(parsedState.description);
              return;
            }
            const cartJson = await (
              await fetch(`${FoxTheme.routes.cart_url}`, { ...FoxTheme.utils.fetchConfig() })
            ).json();
            cartJson['sections'] = parsedState['sections'];

            FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cartJson });
            document.dispatchEvent(
              new CustomEvent('product-ajax:added', { detail: { product: parsedState } })
            );
            this.cartDrawerElement && this.cartDrawerElement.show(this.lastClickedElement);
          })
          .catch((e) => console.error(e))
          .finally(() => this.toggleLoading(false));
      }
    }
  );
}
